import React from "react";
import {observer} from "mobx-react";
import {autorun} from "mobx";

import EsriScaleBar from "@arcgis/core/widgets/ScaleBar";
import EsriScaleBarViewModel from "@arcgis/core/widgets/ScaleBar/ScaleBarViewModel";
import {ScaleBarConfiguration} from "../../config/scalebar-configuration";
import {IAppStore, withStore} from "../../stores/abstract-app-store";


interface ScalebarProps {
    config: ScaleBarConfiguration;
    onLoad?: (scaleBarViewModel: EsriScaleBarViewModel) => any;
    store?: IAppStore; // this is injected by withStore
}

@observer
class ScaleBarBase extends React.Component<ScalebarProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    scaleBar: any;
    scaleBarRef: any;
    constructor(props: ScalebarProps) {
        super(props);
        this.state = {
            viewModel: null,
            isLoading: true
        };
        this.scaleBarRef = React.createRef();
    }

    componentDidMount(): void {
        const {config, onLoad, store} = this.props;

        // rerun until map view is ready and layer list view model is loaded
        this.autorunDisposers.push(autorun((reaction: any) => {
            if (store?.uiStore.widgets.has("scalebar")) {
                reaction.dispose(); // stop autorun
                return;
            }

            if (!store?.mapStore.view) {
                return;
            }
            const scaleBar = this.loadScaleBar(config, store.mapStore.view);
            if (!scaleBar) {
                return;
            }
            /* console.log(scaleBar);
            this.watchHandles.push(
                scaleBar.viewModel.watch("view.zoom",
                    (newValue: any, oldValue: any, propertyName: string, target: any) => {
                    this.setState({viewModel: target});
                    console.log('handle view');
                    console.log(target);
                })
            );*/
            this.setState({
                isLoading: false,
                viewModel: scaleBar.viewModel
            });
            store?.uiStore.addWidget("scalebar", this);

            if (onLoad) {
                // call the hook
                onLoad(scaleBar.viewModel);
            }
            reaction.dispose();
        }));
    }

    componentWillUnmount(): void {
        const {store} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
        store?.uiStore.removeWidget("scalebar");
    }

    loadScaleBar(scaleBarConfig: ScaleBarConfiguration,
                 view: __esri.MapView | __esri.SceneView): __esri.ScaleBar {

        const config = scaleBarConfig as __esri.ScaleBarProperties;
        config.container = this.scaleBarRef.current;
        const props = {
            view,
            ...config
        };
        return new EsriScaleBar(props);
    }

    render(): JSX.Element | null {
        return (
            <div className="scalebarWrapper" ref={this.scaleBarRef}/>
        );
    }
}

export const ScaleBar = withStore(ScaleBarBase);
